module.exports = __webpack_public_path__ + "static/media/comment-dollar.14c65af3.svg";